import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navItems = [
    { label: "首页", path: "/" },
    { label: "网红黑料", path: "/category/wanghong-heiliao" },
    { label: "明星八卦", path: "/category/mingxing-bagua" },
    { label: "社会奇闻", path: "/category/shehui-qiwen" },
    { label: "关于我们", path: "/about" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-100/95 backdrop-blur-md border-b border-background-300/40"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between" aria-label="主导航">
        <Link
          to="/"
          className="flex items-center gap-2.5 group cursor-pointer"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-fire-fill text-foreground-50 text-lg"></i>
          </div>
          <span className="text-lg font-heading text-foreground-50 tracking-wider">
            911爆料网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === item.path
                  ? "bg-primary-500/20 text-primary-300 font-medium"
                  : "text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            className="flex items-center gap-1.5 px-4 py-2 text-sm text-foreground-300 hover:text-foreground-100 transition-colors cursor-pointer whitespace-nowrap"
            aria-label="搜索"
          >
            <i className="ri-search-line text-base w-4 h-4 flex items-center justify-center"></i>
            <span>搜索</span>
          </button>
          <button
            className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-foreground-50 text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap dark:text-foreground-950"
            aria-label="我要爆料"
          >
            我要爆料
          </button>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? "关闭菜单" : "打开菜单"}
        >
          <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-300/40">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-3 text-sm rounded-lg transition-all duration-200 cursor-pointer ${
                  location.pathname === item.path
                    ? "bg-primary-500/20 text-primary-300 font-medium"
                    : "text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="border-t border-background-300/40 mt-2 pt-3 flex gap-2">
              <button className="flex-1 px-4 py-2.5 text-sm text-foreground-300 hover:text-foreground-100 bg-background-200/50 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-center">
                搜索爆料
              </button>
              <button className="flex-1 px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap text-center dark:text-foreground-950">
                我要爆料
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}